/*
 * Public API Surface of cookie-service
 */

export * from './lib/service/cookie-config.service';
export * from './lib/interface/cookie-config.interface';
export * from './lib/cookie-service.component';
export * from './lib/cookie-service.module';
